import { storage } from "services/config/storage"
import { getImageData } from "utils/helper"
import ProctoringApi from "services/apis/proctoring"
import { PERMISSION_ERRORS } from "constants/globalConstants"

export const useImgComparison = ({ linkId, setShowPermissionModal }) => {

    const sendSnapshot = async ({ imgSrc, isImageCritical, criticalReason }) => {
        try {
            const res = await ProctoringApi.sendUserSnapShot({ linkId, imgSrc, isImageCritical, criticalReason })
            if (res.success) setShowPermissionModal(false)
            if (res.data.createdAt) storage.set.latestSnapshot(res.data.createdAt, linkId)
        } catch (err) {
            setShowPermissionModal(PERMISSION_ERRORS.API_FAILURE)
        }
    }

    const proctorGameplayCapture = (imageSrc) => {
        const worker = new Worker(new URL("../utils/imageProctoringWorker.js", import.meta.url))

        worker.onmessage = async (event) => {
            const obj = event.data
            try {
                await sendSnapshot({ linkId, imgSrc: imageSrc, isImageCritical: obj.isImageCritical, criticalReason: obj.criticalReason })
            } catch { } finally {
                worker.terminate()
            }
        }

        const referenceImgElement = new Image()
        referenceImgElement.src = storage.get.userRefImg()
        referenceImgElement.onload = async () => {
            const referenceImgData = getImageData(referenceImgElement)

            const currentImgElement = new Image()
            currentImgElement.src = imageSrc
            currentImgElement.onload = async () => {
                const currentImgData = getImageData(currentImgElement)
                try {
                    worker.postMessage({ currentImgData, referenceImgData })
                } catch (e) {
                    console.error(e)
                }
            }
            currentImgElement.onerror = async () => {
                try {
                    await sendSnapshot({ linkId, imgSrc: imageSrc, isImageCritical: false, criticalReason: "" })
                } catch { }
            }
        }
        referenceImgElement.onerror = async () => {
            try {
                await sendSnapshot({ linkId, imgSrc: imageSrc, isImageCritical: false, criticalReason: "" })
            } catch { }
        }
    }

    return { proctorGameplayCapture }
}